import React from "react";
import { useLocation } from "react-router-dom";
import {
  IconMessageDots,
  IconBook,
  IconMail,
  IconPhone,
  IconQuestionMark,
  IconChevronDown,
} from "@tabler/icons-react";
import { FormattedMessage } from "react-intl";
import "./SupportBubble.css";
const SupportBubble: React.FC = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  const wrapperRef = React.useRef<HTMLDivElement>(null);

  const location = useLocation();
  const { pathname } = location;
  const pages = ["/chats", "/leads", "/leads/payments", "/leads/leads"];

  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const hide = pages.includes(pathname);
  const style = hide ? { display: "none" } : undefined;

  return (
    <div
      className={`support-bubble-wrapper ${isOpen ? "open" : ""}`}
      style={style}
      ref={wrapperRef}
    >
      <div className="support-menu-wrapper">
        <div className="support-menu">
          {/*
          <a
            href="https://app.visitoai.com/web-chat?id=12a3d329e271e23892006008644f5f9c"
            target="_blank"
            rel="noopener noreferrer"
            className="support-menu-item"
          >
            <div>
              <IconMessageDots size={24} />
            </div>
            <div>
              <FormattedMessage id="support.liveChat" />
            </div>
          </a>
          */}
          <a
            href="https://docs.visitoai.com/Getting-started/home"
            target="_blank"
            rel="noopener noreferrer"
            className="support-menu-item"
          >
            <div>
              <IconBook size={24} />
            </div>
            <div>
              <FormattedMessage id="support.guide" />
            </div>
          </a>
          <a href="mailto:help@visitoai.com" className="support-menu-item">
            <div>
              <IconMail size={24} />
            </div>
            <div>
              <FormattedMessage id="support.email" />
            </div>
          </a>
          <a
            href="https://cal.com/team/visito/support"
            target="_blank"
            rel="noopener noreferrer"
            className="support-menu-item"
          >
            <div>
              <IconPhone size={24} />
            </div>
            <div>
              <FormattedMessage id="support.call" />
            </div>
          </a>
        </div>
      </div>

      <div className="support-bubble" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? (
          <IconChevronDown size={24} className="support-bubble-icon" />
        ) : (
          <IconQuestionMark size={24} className="support-bubble-icon" />
        )}
      </div>
    </div>
  );
};

export default SupportBubble;
